common.View.create('website::layouts.Main', {

    onDOMLoad()
    {
        this.linkColors();
        this.paginationLinkColors();
    },

    linkColors()
    {
        const linksWithoutClass = this.element.find('a:link:not([class])').get();

        linksWithoutClass.forEach(link => {
            const styledAncestor = this.findAncestorWithStyle(link);
            if (styledAncestor) {
                const bgColor = this.getComputedBackgroundColor(styledAncestor);
                if (bgColor && this.isBackgroundDark(bgColor)) {
                    link.classList.add('textSecondary');
                } else {
                    link.classList.add('textBlue');
                }
            } else {
                link.classList.add('textBlue');  // default to blue
            }
        });
    },

    paginationLinkColors()
    {
        const links = document.querySelectorAll('.paginationWrapper a:not(.active)');
        links.forEach(link => {
            const bgColor = this.getComputedBackgroundColor(link);
            if (bgColor && this.isBackgroundDark(bgColor)) {
                link.classList.add('paginationItemSecondary');
            } else {
                link.classList.add('pagionationItemBlue');
            }
        });

        const activeLinks = document.querySelectorAll('.paginationWrapper li.active');
        activeLinks.forEach(link => {
            const bgColor = this.getComputedBackgroundColor(link);
            if (bgColor && this.isBackgroundDark(bgColor)) {
                link.classList.add('bg-palette-blue');
            } else {
                link.classList.add('bg-palette-primary');
            }
        });
    },

    getComputedBackgroundColor(element) {
        let color = getComputedStyle(element).backgroundColor;
        if (color === 'rgba(0, 0, 0, 0)' || color === 'transparent') {
            return element.parentElement ? this.getComputedBackgroundColor(element.parentElement) : null;
        } else {
            return color;
        }
    },

    findAncestorWithStyle(el) {
        while (el && el !== document.body) {
            if (el.style && /background|color/.test(el.style.cssText)) {
                return el;
            }
            el = el.parentElement;
        }
        return null;
    },

    isBackgroundDark(color) {
        const rgb = color.match(/\d+/g); 
        const brightness = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return brightness < 125;  // raised threshold
    }
});
